var _rect, _polygon, _rect2, _rect3, _rect4, _path, _path2, _path3, _rect5, _rect6, _path4, _path5, _path6, _path7, _polygon2, _path8, _rect7, _polygon3, _polygon4, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _polygon5, _polygon6, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _polygon7, _polygon8, _polygon9, _path22, _path23, _path24, _path25, _circle, _path26, _rect8, _path27, _rect9, _circle2, _rect0, _path28, _g, _path29, _line, _line2, _path30, _path31, _path32, _path33, _ellipse, _line3, _path34, _path35, _path36, _line4, _path37, _path38, _path39, _line5, _path40, _rect1, _path41, _g2, _g3, _rect10, _path42;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscuss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "a",
    width: 865.76,
    height: 682.89,
    viewBox: "0 0 865.76 682.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 624.67,
    y: 486.5,
    width: 102.05,
    height: 9.47,
    fill: "#f1f2f2",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "705.67 468.68 778.1 616.18 788.57 616.18 728.29 466.23 705.67 468.68",
    fill: "#f1f2f2",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 561.06,
    y: 602.45,
    width: 83.38,
    height: 11.09,
    rx: 5.54,
    ry: 5.54,
    fill: "#f1f2f2",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 154.69,
    y: 45.15,
    width: 506.01,
    height: 306.11,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 505.31,
    y: 77.05,
    width: 107.78,
    height: 241.21,
    fill: "#f1f2f2",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M553.74,133.51h38.5c5.14,0,9.3,4.16,9.3,9.3h0c0,5.14-4.16,9.3-9.3,9.3h-38.5c-5.14,0-9.3-4.16-9.3-9.3h0c0-5.14,4.16-9.3,9.3-9.3Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M553.74,158.53h38.5c5.14,0,9.3,4.16,9.3,9.3h0c0,5.14-4.16,9.3-9.3,9.3h-38.5c-5.14,0-9.3-4.16-9.3-9.3h0c0-5.14,4.16-9.3,9.3-9.3Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M553.74,184.3h38.5c5.14,0,9.3,4.16,9.3,9.3h0c0,5.14-4.16,9.3-9.3,9.3h-38.5c-5.14,0-9.3-4.16-9.3-9.3h0c0-5.14,4.16-9.3,9.3-9.3Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 205.71,
    y: 141.85,
    width: 106.49,
    height: 112.91,
    fill: "#f1f2f2",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 357.76,
    y: 77.05,
    width: 106.49,
    height: 241.21,
    fill: "#f1f2f2",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M201.54,87.32h54.53c9.04,0,16.36,7.32,16.36,16.36h0c0,9.04-7.32,16.36-16.36,16.36h-54.53c-9.04,0-16.36-7.32-16.36-16.36h0c0-9.04,7.32-16.36,16.36-16.36Z",
    fill: "#f1f2f2",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M771.46,361.74l-15.59,70.11c-.14,.5-.27,1-.39,1.51-1.15,4.82-9.45,35.51-35.51,40.33-2.21,.39-4.46,.58-6.71,.56h-120.33l26.51-57.86c1.64-3.58,3.79-6.9,6.39-9.85l86.62-98.38c2.49-2.84,5.38-5.32,8.57-7.34,7.65-4.84,22.2-11.95,38.03-8.84,11.1,2.18,19.29,11.68,19.98,22.97,.6,9.83-3.79,24.99-7.57,46.8Z",
    fill: "#f1f2f2",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M561.59,102.78l-.37-.11c-1-.24-2.07-.5-3.12-.72-.4-.06-.72-.38-.77-.78-.48-2.27-1.37-4.42-2.64-6.36-.25-.32-.25-.78,0-1.1,.58-.9,1.13-1.81,1.7-2.71,.16-.24,.17-.39,0-.6l-3-3c-.13-.19-.39-.23-.57-.1-.01,0-.03,.02-.04,.03-.84,.55-1.71,1-2.54,1.61-.42,.35-1.02,.35-1.44,0-1.8-1.19-3.82-2.03-5.93-2.47-.65-.05-1.16-.57-1.21-1.22-.18-1-.47-2.07-.71-3.1h-5c-.26,1.15-.54,2.28-.78,3.41-.07,.43-.41,.77-.84,.84-2.25,.48-4.39,1.37-6.31,2.63-.32,.25-.78,.25-1.1,0-.88-.57-1.8-1.1-2.67-1.68-.19-.18-.49-.16-.66,.03-.02,.02-.04,.05-.06,.07-.52,.56-1.07,1.08-1.62,1.63l-1.59,1.59c.63,1,1.22,2,1.85,3,.3,.39,.3,.92,0,1.31-1.21,1.82-2.07,3.86-2.53,6-.07,.52-.48,.93-1,1-1.09,.22-2.16,.5-3.27,.75v4.76c0,.11,.21,.28,.35,.32,1,.25,2,.5,3.07,.71,.45,.06,.81,.42,.86,.88,.46,2.2,1.34,4.3,2.57,6.18,.3,.39,.3,.92,0,1.31-.63,1-1.22,1.94-1.8,2.86l3.56,3.58c1-.61,2-1.23,3-1.88,.3-.21,.7-.21,1,0,1.98,1.3,4.18,2.22,6.49,2.71,.37,.06,.66,.36,.7,.73,.23,1,.5,2.1,.73,3.16,.06,.27,.15,.37,.44,.36h4.3c.28,0,.38-.09,.44-.35,.23-1.06,.5-2.11,.73-3.17,.05-.39,.36-.7,.75-.75,2.28-.47,4.45-1.38,6.4-2.66,.31-.24,.75-.24,1.06,0l2.43,1.52,.58,.35,3.57-3.54c-.59-.94-1.17-1.93-1.81-2.88-.32-.39-.32-.96,0-1.35,1.2-1.83,2.05-3.86,2.5-6,.05-.6,.53-1.08,1.13-1.13,1.07-.2,2.13-.48,3.2-.73l-.03-4.94Z",
    fill: "#8EB2BC",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M602.27,266.61s28.33-23.5,68.89-12.07c0,0,27.68,4.35,47.64,59.07,0,0-7.08,11.27-35.73,15.46l13.2,32.83-84.4,4.51-4.46-40.56s-17.07,1.93-30.26-14.17c.01,0,6.54-30.54,25.12-45.07Z",
    fill: "#8EB2BC",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "259.98 562.66 260.06 491.92 296.71 487.1 282.58 562.66 259.98 562.66",
    fill: "#f2b3c1",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M255.66,560.21h34.21l-3.72,33.35s25.24,.13,28.62,12.36h-62.52l3.41-45.71Z",
    fill: "#6B8C95",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 252.25,
    y: 605.92,
    width: 62.53,
    height: 7.08,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "208.31 487.1 200.86 562.66 225.34 562.66 247.16 491.36 208.31 487.1",
    fill: "#f2b3c1",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "301.51 260.58 234.87 260.58 234.87 279.17 301.51 277.96 301.51 260.58",
    fill: "#f2b3c1",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M284.62,172.83v4.45s-6.05,10.39-29.47,4.59l.49-31.3c1.39,.19,2.8,.04,4.12-.42,1.85,6.38,6.1,11.8,11.87,15.1,0,0,3.04,4.43,12.99,7.58Z",
    fill: "#f2b3c1",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M160.75,472.8l74.12-193.63,66.64-1.21,52.36,189.53s-88.34,59.4-193.12,5.31Z",
    fill: "#8EB2BC",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M195.42,382.21c38.67-9,54.42,2.69,54.42,2.69,0,0,19.61,11.51-6.27,45.24,0,0-27.73,35.58-54.92,54.66",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M206.17,354.15s45.12-13.17,61.05-43.6c0,0,7.49-11.61,1.57-32",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M303.17,283.96s-26.76,27.53-17.05,66.37,43.27,28.49,43.27,28.49",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M228.14,494.04s53.73-91.31,104.13-104.8",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M259.98,495.54s42.75-81.48,87.77-50.29",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "470.54 504.09 520.61 454.13 549.94 476.63 486.52 520.07 470.54 504.09",
    fill: "#f2b3c1",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "570.76 603.34 600.86 539.32 569.76 519.33 550.32 593.7 570.76 603.34",
    fill: "#f2b3c1",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M199.17,232.18s-29.89,64.49-52.23,99.84c0,0-24.24,28.68-42.81,36-.71,.26-1.26,.85-1.45,1.58-.19,.78,.09,1.58,2.21,1.32,0,0,1.61,3.64,15.13,.05,13.52-3.59,28.85-17.92,28.85-17.92,0,0,3.05-1.77,3.7,2.9,0,0,3,18.77,8.21,15.51,0,0-4-17.06-2-22.08,1.26-3.13,1.96-6.44,2.09-9.8,.1-2.57,1-5.03,2.64-7.01,10.17-12.23,46.29-56.37,66.65-90.39,0,0-19.78-2-31-10Z",
    fill: "#f2b3c1",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M338.87,199.34l24.23,10.33s30.48-43.09,36.21-51.57c0,0,6.88-13.07,2.75-27.51,0,0,6.65-.92,6.65,12.61,0,0,9-3.29,18.59-17.79,.64-.96,1.92-1.25,2.91-.66,.77,.51,1.33,1.63,.88,4-.44,2.19-1.48,4.23-3,5.87l-7.5,8.36s6.44,1.13,9.53,5.22c.82,1.09,1.07,2.51,.81,3.85-.58,3-2.31,8.44-7.13,8.08,0,0-1.61,7-13.76,6.71,0,0-19.31,52.3-34.73,68.14-2.28,2.36-5.45,3.64-8.72,3.53-5.39-.21-21.28-3.36-37.73-12.45l-.57-2.8c-1.87-8.89,2.6-18.06,9.88-23.5,.42-.31,.67-.47,.67-.47",
    fill: "#f2b3c1",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M633.17,218.68v22c0,9.38-6.3,17.29-14.9,19.72-1.78,.51-3.66,.78-5.6,.78-11.32,0-20.5-9.18-20.5-20.5v-22c0-11.32,9.18-20.5,20.5-20.5,5.66,0,10.78,2.3,14.5,6,3.7,3.72,6,8.84,6,14.5Z",
    fill: "#f2b3c1",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M639.27,233.02s2.87-1.76,3.13-6.48c.28-3.11-1.52-6.03-4.43-7.16,0,0-3.76-1.67-7,2.62,0,0-17.21-9.47-19.14-15.75-2.76,2.11-5.79,3.85-9,5.16-4.36,1.52-7.86,4.82-9.64,9.08-.37,.9-.64,1.83-.81,2.79,0,0-20.25-10.13-3-21.12,0,0,4.79-12.98,18.79-15.98,0,0,19.32-5.32,26.8,10.37,0,0,18.02-1.43,21.77,15.98,.96,4.47,.6,9.12-.8,13.47-2.44,7.59-7.54,21.05-11.63,16.14l-1.74-4.42c-.71-1.8-1.83-3.41-3.27-4.7h0",
    fill: "#002346",
    stroke: "#002346",
    strokeMiterlimit: 10,
    strokeWidth: 0.65
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M648.3,253.09c-3.86,23.5-26.72,15.13-26.72,15.13l-3.31-7.82c8.6-2.43,14.9-10.34,14.9-19.72v-9.16h3.54c2.66,1.26,4.74,3.47,5.83,6.2l5.76,15.37Z",
    fill: "#f2b3c1",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M607.42,325.85l1.21,11c-23.58,42.05-39.36,35-39.36,35-21.89-5.31-2.74-69.53-2.74-69.53l8.05-28.65,4.75-28.11c.37-2.21,1.29-4.32,2.81-5.98,1.84-2,4.57-3.55,7.65-.51,0,0,3.82-1.41,4.2,2.92,0,0,4.87-2.2,4.41,1.91,0,0,8.3-1.69,6,17.13-.11,.93-.95,1.6-1.88,1.5-.12-.01-.24-.04-.35-.08-1.17-.45-2.62-1.81-3.75-5.52,0,0,.16,12.08-8.69,14.81,0,0-1.5,40.18-2.6,48.72-.02,.02,11.43,7,20.29,5.39Z",
    fill: "#f2b3c1",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M628.75,328.59c-6.98,0-12.63,5.65-12.63,12.63s5.65,12.63,12.63,12.63,12.63-5.65,12.63-12.63c0-6.97-5.64-12.62-12.61-12.63h-.02Zm0,19.47c-3.78,0-6.84-3.06-6.84-6.84s3.06-6.84,6.84-6.84c3.78,0,6.84,3.06,6.84,6.84s-3.06,6.84-6.84,6.84h0Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M628.75,324.56v30.42h-28.23v-30.42h28.23Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "417.48 285.61 462.55 360.94 588.42 360.94 550.76 285.61 417.48 285.61",
    fill: "#f1f2f2",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "421.67 280.78 417.48 285.61 550.76 285.61 588.42 360.94 592.93 356.43 555.26 280.78 421.67 280.78",
    fill: "#f1f2f2",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "528.22 338.08 521.56 360.94 518.24 372.32 480.9 372.32 493.78 338.08 528.22 338.08",
    fill: "#8EB2BC",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M601.67,568.68l44.53-129.84-42.18-10-22.35,25.84-30,97c2,1,50,17,50,17Z",
    fill: "#6B8C95",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M713.94,318.25l11.82,35.81s6.14,16.49-12.67,18.26h-107.17c-3.12,0-6.2-1.06-8.49-3.18-1.99-1.83-3.12-4.15,.36-6.09,0,0-4.37-4.21,.46-6.14,0,0-4.18-4.18,.32-5.79,0,0-1.75-3.07,0-4.79,.98-.92,2.49-.96,3.51-.09,2.23,1.82,8.08,5.64,18.09,6,0,0-11.1-12.07-3.06-9.49,0,0,18.41,8.78,24.46,13.06,1.4,.99,3.12,1.38,4.81,1.14,4.62-.67,13.02-1.92,14.3-2.27,1.77-.49,25.14-4.73,31.59-2.82l-9.19-22.79s22.94-3.13,30.87-10.82Z",
    fill: "#f2b3c1",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M388.39,243.11h45.23c4.34,0,7.86,3.52,7.86,7.86h0c0,4.34-3.52,7.86-7.86,7.86h-45.23c-4.34,0-7.86-3.52-7.86-7.86h0c0-4.34,3.52-7.86,7.86-7.86Z",
    fill: "#8EB2BC",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M394.3,138.85c.02-6.49-5.23-11.78-11.72-11.8-6.49-.02-11.78,5.23-11.8,11.72,0,2.95,1.09,5.8,3.09,7.98l2.51,2.74,6.18,7.11,7.09-8.39h0c2.93-2.22,4.66-5.69,4.65-9.37Z",
    fill: "#6B8C95",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 382.91,
    cy: 138.95,
    r: 4.08,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M502.06,516.17l-21.74-26.43-23.39,24.05s-16.13-19.41-27.75-14.25l39.72,48.29,33.16-31.66Z",
    fill: "#8EB2BC",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 442.79,
    y: 494.68,
    width: 7.08,
    height: 62.53,
    transform: "translate(-232.47 403.22) rotate(-39.43)",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M582.12,587.63l-31.64-13.06-9.29,32.25s-23.37-9.51-31.17,.51l57.81,23.86,14.29-43.56Z",
    fill: "#8EB2BC",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 533.98,
    y: 591.28,
    width: 7.08,
    height: 62.53,
    transform: "translate(-243.01 881.88) rotate(-67.57)",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 538.5,
    cy: 105.28,
    r: 9.36,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 258.17,
    y: 114.18,
    width: 40,
    height: 54,
    rx: 20,
    ry: 20,
    fill: "#f2b3c1",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M307.97,225.68c2.41,8.45,5.07,36,5.07,36l-81.37,.73v-14.73s-17-6-38.87-17.04c0,0,19.94-55.47,60.51-59,0,0,34.06-6.54,56.46,7.37l29.67,17.62s-5.07,13.47-10.63,36.86l-20.84-7.81Z",
    fill: "#6B8C95",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 249.29,
    cy: 103.84,
    r: 12.54,
    fill: "#002346",
    stroke: "#002346",
    strokeMiterlimit: 10,
    strokeWidth: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.23,
    cy: 110.91,
    r: 9.64,
    fill: "#6B8C95",
    stroke: "#002346",
    strokeMiterlimit: 10,
    strokeWidth: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.37,172.33c1.49,2.87,4.54,4.6,7.77,4.53,7.98-.2,12.4-5.39,12.4-5.39,7.8,1.94,11.38,1.15,11.38,1.15-8.24-8.85-6.41-17.47-4.58-21.83,.67-1.6,1.74-3,3.12-4.04,9.19-6.93,8.04-14.3,8.04-14.3,10.72-1.69,16.24-5.37,18.77-7.73,.5-.46,1.14-.7,1.76-.7,.76,0,1.5,.33,2.02,.96,.18,.23,.34,.51,.44,.81,.98,2.91,1.29,3.48,2.89,6.39l1.98,3.6c3.25-8.05,.27-26.6-10.2-31.17-1.8-.78-3.64-1.36-5.44-1.76-3.02-.67-5.95-.88-8.48-.85-4.69,.04-8,.82-8,.82-25.34,2-33.34,45.98-33.34,45.98-3.79,12.6-2.52,19.68-.53,23.52Z",
    fill: "#002346",
    stroke: "#002346",
    strokeMiterlimit: 10,
    strokeWidth: 0.65
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M263.17,141.73c0,3.7-2.57,7.07-5.74,7.07s-5.75-3.37-5.75-7.07,2.57-6.7,5.75-6.7,5.74,3,5.74,6.7Z",
    fill: "#f2b3c1",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 307.97,
    y1: 225.68,
    x2: 287.67,
    y2: 218.68,
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 231.67,
    y1: 247.68,
    x2: 245.67,
    y2: 222.68,
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M104.89,370.92s10.28-3.74,24.28-14.74",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M111.64,372.45s11.02-4.77,21.02-11.77",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M430.93,152.05s-3.77-2.87-11.77-3.87",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M428.93,157.05s-3.77-2.87-11.77-3.87",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 636.06,
    cy: 226.54,
    rx: 6.34,
    ry: 7.51,
    fill: "#f2b3c1",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 598.42,
    y1: 256.93,
    x2: 598.17,
    y2: 249.18,
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M589.79,239.07s-4.62,1.11-4.62,6.11",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M593.99,241.99s-3.32,1.69-3.32,4.69",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M598.4,243.9s-2.73,.78-2.73,3.78",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 611.67,
    y1: 292.68,
    x2: 608.67,
    y2: 323.68,
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M598.56,351.12s5.61,5.06,17.61,6.06",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M598.24,356.91s3.43,4.77,16.43,4.77",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M597.78,363.05s4.43,3.74,16.66,3.19",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 683.07,
    y1: 329.07,
    x2: 669.17,
    y2: 299.18,
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M527.67,512.68l76.12-80.44s62.42,19.11,84.2,6.31c.36-.21,.72-.43,1.1-.63,3.42-1.81,26.19-15.48,16.35-53.48h-133.27l-83.5,85.24,39,43Z",
    fill: "#6B8C95",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 588.42,
    y: 380.08,
    width: 12.1,
    height: 222.37,
    fill: "#f1f2f2",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M431.75,372.32h346.58c3.35,0,6.06,2.71,6.06,6.06h0c0,3.35-2.71,6.06-6.06,6.06H431.75c-3.35,0-6.06-2.71-6.06-6.06h0c0-3.35,2.71-6.06,6.06-6.06Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M679.19,549.09c.2,2.34,.51,4.98,.96,7.67,0,0,9.48-31.02,40.64-27.02l-6.12-13.48-5.06-5.06c-10.16,5.28-20,3.69-26.72,17.32-3.14,6.36-4.31,13.51-3.69,20.58Z",
    fill: "#7cd295",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.04,519.38c-28.12,.03-32.32-41.41-3.91-75.9,.09-.11,.27-.04,.26,.11-1.12,11.76,33.4,53.9,10.78,73.19-1.99,1.69-4.51,2.6-7.12,2.6Z",
    fill: "#7cd295",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.34,503.9c-17.74-10.53-13.74-42.1,38.83-60.73,.1-.03,.2,.06,.16,.15-.6,1.71-4.08,12.88-5.91,44.4-.49,8.4-12.49,28.4-33.08,16.17Z",
    fill: "#7cd295",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.7,573.09c.8,6.21-41.3,6.21-40.5,0-.8-6.21,41.3-6.21,40.5,0Z",
    fill: "#002346",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.36,628.09c-1.82-.27-48.18,.79-48.29-.86-9.13-4.33-9.52-18.47-9.52-18.47-1.38-18.87,15.65-28.99,15.65-28.99v-6.67c-.8,6.21,41.3,6.21,40.5,0v7.13c22.29,14.63,17.77,46.38,1.66,47.86Z",
    fill: "#6B8C95",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.08,588.51c.05,3.58-5.58,3.58-5.52,0-.05-3.58,5.58-3.58,5.52,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.37,596.8c.05,3.58-5.58,3.58-5.52,0-.05-3.58,5.58-3.58,5.52,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M794.75,610.14c.05,3.58-5.58,3.58-5.52,0-.05-3.58,5.58-3.58,5.52,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.38,620.27c.05,3.58-5.58,3.58-5.52,0-.05-3.58,5.58-3.58,5.52,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M764.83,623.03c.05,3.58-5.58,3.58-5.52,0-.05-3.58,5.58-3.58,5.52,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.34,620.27c.05,3.58-5.58,3.58-5.52,0-.05-3.58,5.58-3.58,5.52,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.68,612.44c.05,3.58-5.58,3.58-5.52,0-.05-3.58,5.58-3.58,5.52,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.06,596.8c.05,3.58-5.58,3.58-5.52,0-.05-3.58,5.58-3.58,5.52,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.18,587.59c.05,3.58-5.58,3.58-5.52,0-.05-3.58,5.58-3.58,5.52,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758.39,595.88c.05,3.58-5.58,3.58-5.52,0-.05-3.58,5.58-3.58,5.52,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.8,603.24c.05,3.58-5.58,3.58-5.52,0-.05-3.58,5.58-3.58,5.52,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.01,612.44c.05,3.58-5.58,3.58-5.52,0-.05-3.58,5.58-3.58,5.52,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.13,604.62c.05,3.58-5.58,3.58-5.52,0-.05-3.58,5.58-3.58,5.52,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.97,588.97c.05,3.58-5.58,3.58-5.52,0-.05-3.58,5.58-3.58,5.52,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.26,598.64c.05,3.58-5.58,3.58-5.52,0-.05-3.58,5.58-3.58,5.52,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.7,605.08c.05,3.58-5.58,3.58-5.52,0-.05-3.58,5.58-3.58,5.52,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.5,614.29c.05,3.58-5.58,3.58-5.52,0-.05-3.58,5.58-3.58,5.52,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.55,542.03c-15.18-12.36-36.76,4.61-15.19,25.77,0,0,11.05,10.12,15.65,20.71,0,0,21.17-15.19,21.63-35.9,0,0,0-21.17-22.09-10.59Z",
    fill: "#7cd295",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.71,539.46c23.85-42.04,34.03,1.19,69.93-4.8,.54-48.33-69.4-46.3-69.93,4.8Z",
    fill: "#7cd295",
    stroke: "#002346",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.2,579.77s16.99,8.72,40.5,.46",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.71,557.46s10-42,35.45-21.63c3.58,2.86,5.82,7.08,6.91,11.53,1.69,6.9,3.83,19.46,1.14,31.6",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.21,446.96s-47,34-31,126",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.21,511.96s62-1,64,60",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M38.36,405.25c1.59-7.82,7.81-13.81,15.53-15.85,10.92-2.89,28.86-2.47,43.52,22.64,0,0,13.69,22.2,5.67,54.38,0,0-1.65-16.34-27.45-28.04-2.85-1.29-5.79-2.35-8.78-3.27-8.06-2.5-32.21-11.57-28.49-29.85Z",
    fill: "#7cd295",
    stroke: "#002346",
    strokeMiterlimit: 10,
    strokeWidth: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.85,377.92c-3.49,.67-6.69,2.5-8.82,5.34-4.15,5.55-7.29,17.17,3.38,40.47,0,0,15.74,33.23-10,72.9,0,0,41.52-18.52,52-57.73,3.63-13.57,2.58-28.05-3.26-40.82-5.28-11.56-15.22-23.61-33.31-20.16Z",
    fill: "#7cd295",
    stroke: "#002346",
    strokeMiterlimit: 10,
    strokeWidth: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.62,549.75s-20.13-29.72,14.61-59.77c.78-.68,1.59-1.32,2.4-1.96,6.55-5.2,46.1-39.37,18.88-87.21",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.54,412.51s36.78,24.33,20.82,67.32c0,0-17.75,43.89,1.09,69.01",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.12,481.49c.04-4.96,3.14-9.35,7.61-11.48,6.31-3.01,17.28-4.82,29.07,8.81,0,0,10.68,11.76,9.65,31.96,0,.1-.14,.13-.18,.04-.78-1.92-4.82-9.85-19.72-13.51-1.88-.46-3.78-.77-5.7-.99-5.17-.6-20.82-3.37-20.72-14.82Z",
    fill: "#7cd295",
    stroke: "#002346",
    strokeMiterlimit: 10,
    strokeWidth: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.92,505.78s25.13-20.03,51.6-.6c0,0,12.23,9.23,9.01,19.01-1.29,3.9-4.82,6.6-8.87,7.28-5.28,.89-14.27,.61-23.93-7.51,0,0-21.47-16.46-27.8-18.19Z",
    fill: "#7cd295",
    stroke: "#002346",
    strokeMiterlimit: 10,
    strokeWidth: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.46,549.3s3.59-61.91,62.8-42.17",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.61 613 73.98 613 70.39 547.5 133.2 547.5 129.61 613",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10,
    strokeWidth: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.18,573.97c3.64-1.75,9.1-3.73,15.7-3.59,6.44,.14,10.51,2.22,14.81,3.59,6.19,1.97,15.5,3.32,28.7,0",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.18,582.04c3.64-1.75,9.1-3.73,15.7-3.59,6.44,.14,10.51,2.22,14.81,3.59,6.19,1.97,15.5,3.32,28.7,0",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.14,484.7s24.22,9.87,30.51,62.8",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.9
  }))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 188.65,
    y: 605.92,
    width: 68.67,
    height: 7.08,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M196,560.21h37.34l-6.76,31.87s28.33-1.61,30.74,13.84h-68.67l7.35-45.71Z",
    fill: "#6B8C95",
    stroke: "#002346",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscuss);
export default __webpack_public_path__ + "static/media/discuss.5bf8948d78d3de93712bbcf965180c7d.svg";
export { ForwardRef as ReactComponent };